import { Injectable } from '@angular/core';
import { message } from '../constants/messages';

@Injectable()
export class ValidateRulesService {

  public isElementPositive(param: any, fieldName: string,) {
    let errorMessage = '';
    if (typeof param !== 'undefined' && param !== null && param !== '') {
      param = parseInt(param, 10);
      if (param < 0) {
        errorMessage = errorMessage + fieldName + message.shouldBePostiveNumber;
      }
    }
    return errorMessage;
  }
  public requiredElement(
    param: string,
    fieldName: string,
    minLength: number,
    maxLength?: number,
    spl?: boolean
  ) {
    let errorMessage = '';

    if (typeof param !== 'undefined' && param !== null) {
      if (param === '') {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      } else {
        param = param.trim();
        if (maxLength != null) {
          if (param.length < minLength || param.length > maxLength) {
            errorMessage =
              errorMessage + fieldName + message.fieldCompriseMin + minLength + message.maxOf + maxLength + message.characters;
          } else {
            if (this.validatePattern(param, spl) === false) {
              errorMessage = errorMessage + fieldName + message.isInvalidCharIncludesSpChar + param + ')';
            }
          }
        } else {
          if (param.length < minLength) {
            errorMessage =
              errorMessage + fieldName + message.fieldCompriseMin + minLength + message.characters;
          } else {
            if (this.validatePattern(param, spl) === false) {
              errorMessage = errorMessage + fieldName + message.isInvalidCharIncludesSpChar + param + ')';
            }
          }
        }
      }
    } else {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    }

    return errorMessage;
  }

  public booleanElement(param: any, fieldName: string) {
    let errorMessage = '';

    if (typeof param !== 'undefined' && param !== null) {
      if (
        param === 'true' ||
        param === true ||
        param === 'false' ||
        param === false
      ) {
        //empty condition block
      } else {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      }
    } else {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    }

    return errorMessage;
  }

  public idElement(param: any, fieldName: string) {
    let errorMessage = '';
    if (typeof param !== 'undefined' && param !== null && param !== '') {
      param = parseInt(param, 10);
      if (isNaN(param)) {
        errorMessage = errorMessage + param + message.isInValid;
      } else {
        if (param > 0) {
          //empty condition block
        } else {
          errorMessage = errorMessage + fieldName + message.isMandatory;
        }
      }
    } else {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    }

    return errorMessage;
  }

  public minLengththElement(
    param: string,
    fieldName: string,
    minLength: number
  ) {
    let errorMessage = '';
    if (typeof param !== 'undefined' && param !== null) {
      if (param === '') {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      } else {
        param = param.trim();
        if (param.length < minLength) {
          errorMessage =
            errorMessage + fieldName + message.fieldCompriseMin + minLength + message.characters;
        }
      }
    } else {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    }

    return errorMessage;
  }

  public maxLengthElement(param: string, fieldName: string, maxLength: number) {
    let errorMessage = '';
    if (typeof param !== 'undefined' && param !== null) {
      param = param.trim();
      if (param.length > maxLength) {
        errorMessage = errorMessage + fieldName + message.atmost + maxLength + message.characters;
      }
    }
    return errorMessage;
  }

  public requiredGroupElement(params: any, fieldName: string) {
    let errorMessage = '';
    let count = 0;

    if (typeof params !== 'undefined' && params !== null) {
      params.forEach((item: any) => {
        if (item.checked === true) {
          count++;
        }
      });

      if (count === 0) {
        errorMessage = errorMessage + message.chosseAtleastOne + fieldName + '';
      }
    } else {
      errorMessage = errorMessage + message.chosseAtleastOne + fieldName + '';
    }

    return errorMessage;
  }

  public requiredOneSelectedItem(params: any, fieldName: string) {
    let errorMessage = '';

    if (typeof params !== 'undefined' && params !== null) {
      if (params.length === 0) {
        errorMessage = errorMessage + message.chosseAtleastOne + fieldName + '';
      }
    } else {
      errorMessage = errorMessage + message.chosseAtleastOne + fieldName + '';
    }

    return errorMessage;
  }

  public requiredNumberElement(param: any, fieldName: string) {
    let errorMessage = '';
    if (typeof param !== 'undefined' && param !== null) {
      if (param === '') {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      } else {
        if (isNaN(param)) {
          errorMessage = errorMessage + fieldName + message.isInValid;
        } else if (parseInt(param, 10) <= 0) {
          errorMessage = errorMessage + fieldName + message.isInValid;
        }
      }
    } else {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    }
    return errorMessage;
  }

  public emailElement(param: string, fieldName: string) {
    let errorMessage = '';

    if (typeof param === 'undefined') {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    } else {
      param = param.trim();
      if (param === '' || param === null) {
        errorMessage = errorMessage + fieldName + fieldName + message.isMandatory;
      } else if (this.validateEmail(param) === false) {
        errorMessage = errorMessage + fieldName + message.isInValid;
      }
    }
    return errorMessage;
  }
  public multiEmailElement(param: string, fieldName: string) {
    let errorMessage = '';

    if (typeof param === 'undefined') {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    } else {
      if (param === '' || param === null) {
        errorMessage = errorMessage + fieldName + fieldName + message.isMandatory;
      } else if (this.validateMultipleEmails(param) === false) {
        errorMessage = errorMessage + fieldName + message.isInValid;
      }
    }
    return errorMessage;
  }

  public numberElement(param: number, fieldName: string) {
    let errorMessage = '';
    if (isNaN(param)) {
      errorMessage = errorMessage + param + message.isInValid;
    } else {
      if (param > 0) {
        //empty condition block
      } else {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      }
    }

    if (typeof param === 'undefined') {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    } else {
      if (param <= 0) {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      }
    }
    return errorMessage;
  }

  public quillEditorRequiredElement(
    param: string,
    fieldName: string,
    minLength: number,
    maxLength: number
  ) {
    let errorMessage = '';

    if (typeof param !== 'undefined' && param !== null) {
      param = param.replace(/&nbsp;/g, '');
      param = param.replace(/<p>/g, '');
      param = param.replace(/<br>/g, '');
      param = param.replace(/<\/p>/g, '');
      param = param.trim();

      if (param === '') {
        errorMessage = errorMessage + fieldName + message.isMandatory;
      } else {
        if (param.length < minLength || param.length > maxLength) {
          errorMessage =
            errorMessage +
            fieldName +
            message.fieldCompriseMin +
            minLength +
            message.maxOf +
            maxLength +
            message.characters;
        }
      }
    } else {
      errorMessage = errorMessage + fieldName + message.isMandatory;
    }

    return errorMessage;
  }

  public validateEmail(mail: string) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    return false;
  }
  public validateMultipleEmails(mail: string) {
    if (/(([a-zA-Z0-9\-?\.?]+)@(([a-zA-Z0-9\-_]+\.)+)([a-z]{2,3})(\W?[,;]\W?(?!$))?)+$/.test(mail)) {
      return true;
    }
    return false;
  }

  public validatePattern(str: string, spl?: boolean) {
    const regExp = spl === true ? /^[A-Za-z0-9\.]*$/ : /^[a-zA-Z0-9 =+!#&%@,\_\[\]\-\.\(\)<>$]*$/;
    if (!regExp.test(str)) {
      return false;
    } else {
      return true;
    }
  }

  public findDuplicate(id: number, params: any, fieldName: string) {
    let count = 0;
    params.forEach((item: any) => {
      if (item.iplId == id) {
        count++;
      }
    })
    if (count > 1) {
      return true;
    } else {
      return false;
    }
  }
}
